import { render, staticRenderFns } from "./Catheterization.vue?vue&type=template&id=49f8f450&"
import script from "./Catheterization.vue?vue&type=script&lang=js&"
export * from "./Catheterization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports